// ============================================================
// CaseClaimTypeFilter.tsx — the case list's Claim type dropdown, beside
// Status. "All claim types", then ONLY the types among the cases the list
// would show for its other filters (GET /api/cases/claim-types), each with its
// count, and "Not set (n)" if any (utils/claimTypeFilter). Hidden when no
// case has a type and none are "Not set" — unless a filter is on, so it can
// always be turned off.
// ============================================================
import React from 'react'
import { claimTypeFilterOptions, isClaimTypeFilterValue, showClaimTypeFilter, type ClaimTypeFilterValue, type ClaimTypeOptions } from '../../utils/claimTypeFilter'

const CaseClaimTypeFilter: React.FC<{
  value: ClaimTypeFilterValue | null
  options: ClaimTypeOptions | null
  onChange: (v: ClaimTypeFilterValue | null) => void
  className?: string
}> = ({ value, options, onChange, className }) => {
  if (!showClaimTypeFilter(options, value)) return null
  return (
    <select
      value={value ?? ''}
      onChange={(e) => onChange(isClaimTypeFilterValue(e.target.value) ? e.target.value : null)}
      aria-label="Filter by claim type"
      className={className}
    >
      {claimTypeFilterOptions(options, value).map((o) => (
        <option key={o.value || 'all'} value={o.value} title={o.title}>{o.label}</option>
      ))}
    </select>
  )
}

export default CaseClaimTypeFilter
